<template>
    <div class="wrap-input" :class="customClass">
        <label class="label"
               :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
               :for="id">{{label}} <span v-if="isRequired">*</span>
        </label>
        <div class="dropdown-wrapper"
            v-if="isInitSuccess && !isDisableField">
            <div class="flex-fill">
                <InputDropdown
                    v-model="dayInput"
                    addClass="ddl-date-input"
                    :class="{'isSelected' : isDay}"
                    :inputLbl="inputLbl.date"
                    :isFirstSave="isFirstSave"
                    :errorInfo="errorInfoDay"
                    :itemList="dayList"
                    :isShowErrorLbl="true"
                    @input="onDayChange($event)"
                ></InputDropdown>
            </div>
            <div class="flex-fill">
                <InputDropdown
                    v-model="monthInput"
                    addClass="ddl-date-input"
                    :class="{'isSelected' : isMonth}"
                    :inputLbl="inputLbl.month"
                    :isFirstSave="isFirstSave"
                    :errorInfo="errorInfoMonth"
                    :itemList="monthList"
                    :isShowErrorLbl="true"
                    @input="onMonthChange($event);"
                ></InputDropdown>
            </div>
            <div class="flex-fill">
                <InputDropdown
                    v-model="yearInput"
                    addClass="ddl-date-input"
                    :class="{'isSelected' : isYear}"
                    :inputLbl="inputLbl.year"
                    :isFirstSave="isFirstSave"
                    :errorInfo="errorInfoYear"
                    :itemList="yearList"
                    :isShowErrorLbl="true"
                    @input="onYearChange($event)"
                ></InputDropdown>
            </div>
        </div>
        <div class="dropdown-wrapper"
            v-if="isInitSuccess && isDisableField">
            <div class="flex-fill">
                <TextInput
                    addClass="disable-date-field"
                    inputId="edit_profile_day_txt"
                    :inputLbl="lbl.edit_profile.dateDisableInput"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :isTextOnly="true"
                    :blockAutoComplete="true"
                    :errorInfo="errorInfoText[0]"
                    v-model="dayValue"/>
            </div>
            <div class="flex-fill">
                <TextInput
                    addClass="disable-date-field"
                    inputId="edit_profile_month_txt"
                    :inputLbl="lbl.edit_profile.dateDisableInput"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :isTextOnly="true"
                    :blockAutoComplete="true"
                    :errorInfo="errorInfoText[1]"
                    v-model="monthValue"/>
            </div>
            <div class="flex-fill">
                <TextInput
                    addClass="disable-date-field"
                    inputId="edit_profile_year_txt"
                    :inputLbl="lbl.edit_profile.dateDisableInput"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :isTextOnly="true"
                    :blockAutoComplete="true"
                    :errorInfo="errorInfoText[2]"
                    v-model="yearValue"/>
            </div>
        </div>
        <div class="error-text text-right"
             v-if="isShowErrorLbl"
             v-show="!isFirstSave && !errorInfo.isValid && (this.dateValue.year != '' && this.dateValue.month != '' && this.dateValue.day != '')">{{errorInfo.msg}}</div>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";
//helper
import Locale from "@/helper/locale/locale.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import FormHelper from '@/helper/FormHelper.js';
//component
import InputDropdown from "./Dropdown.vue";
import TextInput from "./Text.vue";
import Moment from "moment";
/**
 * @event onDateChange
 */
export default {
    name: "DropdownDateDatepicker",
    components: {
        InputDropdown,
        TextInput
    },
    props: {
        //v-model
        value: Date,
        //props
        inputLbl: Object,
        isDisable: Boolean,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        isRequired: Boolean,
        errorInfo: Object,
        addClass: String,
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            id: '',
            label: '',
            content: this.value,
            customClass: '',
            isDisableField: false,
            isInitSuccess: false,

            dateValue: {
                day: '',
                month: '',
                year: '',
            },

            errorInfoDay: { isValid: false, msg: '' },
            errorInfoMonth: { isValid: false, msg: '' },
            errorInfoYear: { isValid: false, msg: '' },
            ddlInputClass: 'ddl-date-input',

            dayList: [],
            monthList: [],
            yearList: [],

            dayInput: '',
            monthInput: '',
            yearInput: '',
            dayValue: '',
            monthValue: '',
            yearValue: '',

            errorInfoText: [],
            isDay: false,
            isMonth: false,
            isYear: false,
        };
    },
    // watch: {
    //     value: function (val) {
    //         this.content = val;
    //         console.log('datepicker');
    //     }
    // },
    created: function() {
        this.setDayList();
        this.setMonthList();
        this.setYearList();
        this.errorInfoText = FormHelper.genErrorInfo(3);
    },
    mounted: function() {
        this.id = this.inputId;
        this.label = this.inputLbl.name || 'Label';
        this.placeholder = this.inputLbl.placeholder || 'Placeholder';
        this.minLength = this.inputMinLength || null;
        this.maxLength = this.inputMaxLength || null;
        this.customClass = this.addClass || '';

        this.setDateInitial();
        this.validateInput();
        
        this.isInitSuccess = true;
        if (this.isDisable != undefined)
            this.isDisableField = this.isDisable;
        // console.log("error info", this.errorInfoDay);
    },
    methods: {
        //#region setup
        setDayList: function() {
            var day = [];
            for (var i=1 ; i<= 31 ; i++) {
                var d = (i < 10) ? '0' + i : '' + i ;
                day.push({
                    value: i+'',
                    text: d
                });
            }
            this.dayList = day;
        },
        setMonthList: function() {
            var lbl = Locale.getLbl();
            var months = lbl.date.month_full;
            var list = [];
            for (var i in months) {
                var index = parseInt(i, 10) + 1 + '';
                // var index = parseInt(i, 10) + '';
                list.push({
                    value: index,
                    text: months[i],
                });
            }
            this.monthList = list;
        },
        setYearList: function() {
            var currentYear = parseInt(new Date().getFullYear(), 10);
            var yearText = currentYear;
            var localeCode = Locale.getLocaleCode();
            var yearList = [];
            if (localeCode == 1054) {
                yearText = yearText + 543;
            }

            for (var i=0 ; i<100 ; i++) {
                yearList.push({
                    value: currentYear-i + '',
                    text: yearText-i + '',
                });
            }
            this.yearList = yearList;
        },
        setDateInitial: function() {
            if (this.value) {
                var d = this.value.getDate();
                var m = this.value.getMonth();
                var y = this.value.getFullYear();

                this.dayInput = d+'';
                this.monthInput = m+'';
                this.yearInput = y+'';

                this.dayValue = d.toString().padStart(2, '0');
                let monthLbl = Locale.getLbl();
                this.monthValue = monthLbl.date.month_full[m];
                let yearValue = Locale.getLocaleCode() == 1054 ? y += 543 : y;
                this.yearValue = yearValue.toString();

                // console.log(`${d} ${m} ${y}`);
            }
        },
        //#endregion setup

        //#region event dropdown
        onDayChange: function(value) {
            // console.log('day', value);
            this.dateValue.day = value;
            this.isDay = true;
            this.setDateOnChange();
        },
        onMonthChange: function(value) {
            // console.log('month', value);
            this.dateValue.month = value;
            this.isMonth = true;
            this.setDateOnChange();
        },
        onYearChange: function(value) {
            // console.log('year', value);
            this.dateValue.year = value;
            this.isYear = true;
            this.setDateOnChange();
        },
        setDateOnChange: function() {
            this.onSelectDate();

            this.setDateIfNotValid();
            this.validateInput()
            if (this.dateValue.year == '' || this.dateValue.month == '' || this.dateValue.day == '') {
                return;
            }
            var month = parseInt(this.dateValue.month, 10) - 1;

            var datetime = new Date(this.dateValue.year, month, this.dateValue.day);
            var timestamp = DatetimeHelper.convertDateToTimeStampUnix(datetime)
            var formated = DatetimeHelper.dateFullFormat(timestamp);
            var output = {
                datetime: datetime,
                timestamp: timestamp,
                formated: formated,
            };

            let validAge = this.validateAge20(timestamp)
            this.$emit('validateAge', validAge);
            this.$emit('onDateChange', output);
        },
        validateAge20: function(timestamp) {
            // Convert the timestamp to a Moment.js date object
            const dateFromTimestamp = Moment.unix(timestamp);
            // Calculate the difference in years between now and the date from the timestamp
            const age = Moment().diff(dateFromTimestamp, 'years');
            if (age >= 20) {
                this.errorInfoDay.isValid = true;
                this.errorInfoMonth.isValid = true;
                this.errorInfoYear.isValid = true;
                this.errorInfo.isValid = true;
                this.errorInfo.msg = '';
                return true;
            } else {
                this.errorInfoDay.isValid = false;
                this.errorInfoMonth.isValid = false;
                this.errorInfoYear.isValid = false;
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.invalid_age;
                return false;
            }
        },
        onSelectDate: function () {
            this.$emit('onSelectDate');
        },
        //#endregion event dropdown

        //#region function
        setDateIfNotValid: function() {
            if (this.dayInput == '' || this.monthInput == '' || this.yearInput == '') {
                return;
            }
            if (!DatetimeHelper.isDatetimeValid(this.yearInput, this.monthInput, this.dayInput)) {
                var lastDate = DatetimeHelper.getEndOfMonth(this.yearInput, this.monthInput);
                this.dayInput = lastDate.getDate();
                // console.log(lastDate);
                this.refreshInput();
            }
        },
        refreshInput: function() {
            this.isInitSuccess = false;
            this.$nextTick(() => {
                this.isInitSuccess = true;
            });
        },
        //#endregion function

        validateInput: function() {
            // if(!this.inputLbl) return false;
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';

            //Required
            if (this.inputLbl.required &&
                (this.dayInput == '' || this.monthInput == '' || this.yearInput == '')
            ) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return false;
            }

            return true;
        },
    },
}
</script>
<style lang="scss">
    .ddl-date-input.wrap-input {
        margin-top: 0px;

        &.on-error {
            .ddl-input {
                width: 100%;
                .btn-ddl-input {
                    color: #f00;
                    border: 1px solid #f00;
                }
            }
        }
    }
</style>
<style lang="scss" scoped>
.dropdown-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
}
.text-right {
    text-align: right;
}
</style>
